export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      {/* <div className="about--section--img"> */}
      {/* <img src="./img/about-me.png" alt="About Me" /> */}
      {/* <img src="./img/hero_img.png" alt="About Me" /> */}
      {/* </div> */}
      <div className="hero--section--content--box about--section--box">
        {/* <div className="about--section--box"> */}
        <div className="hero--section--content">
          <p className="section--title">About</p>
          <h1 className="skills-section--heading">About Me</h1>
          <p className="hero--section-description">
            I am a dedicated Full Stack Web Developer proficient in the MERN
            stack, which includes MongoDB and MySQL for database management,
            React.js for front-end development, and Node.js and Express.js for
            back-end development. With a deep passion for creating exceptional
            web experiences, I bring a wealth of expertise in AWS cloud
            services, Git version control, HTML, CSS, and JavaScript to the
            table.
          </p>
          <p className="hero--section-description">
            My journey in web development began with a fascination for turning
            ideas into tangible digital solutions. Leveraging MongoDB and MySQL,
            I ensure data integrity and flexibility in my applications. React.js
            is my go-to tool for crafting dynamic and responsive user
            interfaces, while Node.js and Express.js empower me to create robust
            back-end systems, delivering seamless interactions and
            functionality.
          </p>
          <p className="hero--section-description">
            I embrace the power of AWS for scalability and reliability, and Git
            for efficient code management and collaboration. HTML, CSS, and
            JavaScript are the building blocks that enable me to transform
            visions into visually stunning, user-friendly websites.
          </p>
          <p className="hero--section-description">
            As a Full Stack Web Developer, I'm driven to stay at the forefront
            of technology, ensuring every project I undertake is a testament to
            innovation and quality. Thank you for visiting, and I look forward
            to collaborating on exciting web ventures with you.
          </p>
        </div>
      </div>
    </section>
  );
}
